/**
 * このゲームの唯一の識別子。
 *
 * **Phaser を引かない軽いモジュールにしておくこと**。
 * `src/games/registry.ts` から**静的に** import されるので、ここが重いと
 * 初期バンドルにゲーム本体が載ってしまう（遅延読込の意味が消える）。
 *
 * この文字列は5か所で同じでなければならない:
 *   D1 の `game_key` / `src/games/cards/` / `src/locales/<lang>/cards.json` /
 *   `public/assets/cards/` / localStorage の `cards.*`
 * サーバー側の制約は `GAME_KEY_RE = /^[a-z0-9_-]{1,32}$/`。
 */
export const GAME_KEY = 'cards';
